import script from "./newWipCompletion.vue?vue&type=script&setup=true&lang=ts"
export * from "./newWipCompletion.vue?vue&type=script&setup=true&lang=ts"

import "./newWipCompletion.vue?vue&type=style&index=0&id=2612b3ec&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2612b3ec"]])

export default __exports__